import React from 'react';
import { AuthStatus } from '../../types';
import { useTranslation } from 'react-i18next';

interface Props {
	authorzationFilters: AuthStatus;
	toggleFilters: (status: string) => void;
	isDisabled?: boolean;
}

export default ({ authorzationFilters, toggleFilters, isDisabled }: Props) => {
	const { t } = useTranslation();
	return (
		<div className={`authorization_status_filter checkbox_filter ${isDisabled ? 'disabled' : ''}`}>
			<span className="filter_label align_right">
				{t('risk.authorization')}
				<br />
				{t('general.status')}
			</span>
			{Object.keys(authorzationFilters).map((status) => {
				const { color, sign, text, active } = authorzationFilters[status];
				return (
					<div key={status} className="checkbox_button_group">
						<div className={`checkbox_custom chek_only medium tooltip_right margin_right_5 ${color}`}>
							<input
								type="checkbox"
								id="for_label_name"
								checked={active}
								onChange={() => toggleFilters(status)}
							/>

							<span className="check_cover unchecked">{sign}</span>
							<span className="check_cover checked">{sign}</span>
							<span className="tooltip_content">{text}</span>
						</div>
					</div>
				);
			})}
		</div>
	);
};
